<template>
    <div>
        <button class="d-none" @click="openModal()" id="openDeliveryGroupModal">open</button>

        
        <div class="modal fade" id="opendeliveriesModal" tabindex="-1" aria-labelledby="opendeliveriesModal" aria-hidden="true">
               <div class="modal-dialog modal-xl">

                   <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Nouvelle facturation groupée</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fal fa-times"></i>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label class="required">Société</label>
                                    <div class="input-group mb-3">
                                        <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="companySearchInput" type="text" v-model="company">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary"  @click="removeCompany()" type="button" id="button-addon2"><i class="fas fa-trash"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!loading && deliveries && deliveries.length > 0">
                                <div class="col-sm-12 d-flex justify-content-between align-items-center mb-3">
                                    <h5 class="m-0 text-dark" style="font-size: 16px; font-weight: 600;">Liste des bons de livraisons</h5>
                                    <div class="ix-selection-pill" :class="{ 'has-selection': selectedDeliveries.length > 0 }">
                                        <i class="far fa-file-invoice mr-2"></i>
                                        <span class="ix-selection-count">{{ selectedDeliveries.length }}</span>
                                        <span class="ix-selection-label">BL sélectionné{{ selectedDeliveries.length > 1 ? 's' : '' }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-12 mb-3">
                                    <div class="d-flex flex-wrap justify-content-between align-items-center" style="gap: 15px;">
                                        <div class="flex-grow-1 mr-3" style="max-width: 450px;">
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text bg-white"><i class="far fa-search"></i></span>
                                                </div>
                                                <input type="text" class="form-control" placeholder="Rechercher par numéro, désignation, commande, affaire..." v-model="searchQuery" @input="currentPage = 1">
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="ix-table-box" style="max-height: 480px; overflow-y: auto; border: 1px solid #e3e6f0; border-radius: 4px;">
                                        <table class="ix-table ix-table-sm m-0"> 
                                            <thead>
                                                <tr>
                                                    <th class="min">
                                                        <input type="checkbox" v-model="selectAll" @change="addAllSelectedDelivery" />
                                                    </th>
                                                    <th class="min"></th>
                                                    <th>Etat</th>
                                                    <th>Numéro</th>
                                                    <th>Désignation</th>
                                                    <th>Commande</th>
                                                    <th>Affaire</th>
                                                    <th>Date d'expédition</th>
                                                    <th>Date de livraison</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(delivery, index) in paginatedDeliveries" :key="delivery.id" :class="{ 'row-has-invoices': delivery.order && delivery.order.invoices_count > 0 }">
                                                    <td>
                                                        <input type="checkbox" v-model="delivery.isSelected" @change="addSelectedDelivery(delivery)" />
                                                    </td>
                                                    <td class="min">
                                                         <i class="far fa-envelope-open-dollar" v-if="delivery.order && delivery.order.invoices_count > 0" :title="'Nombre de factures: ' + delivery.order.invoices_count"></i> 
                                                    </td>
                                                
                                                    <td class="text-left">
                                                        <span class="ix-state green" v-if="delivery.state == 3">Livré</span>
                                                        <span class="ix-state yellow" v-if="delivery.state == 2">Validé</span>
                                                    </td>
                                                    <td>{{ delivery.number }}</td>
                                                    <td>{{ delivery.designation }}</td>
                                                    <td>
                                                        <span v-if="delivery.order">{{ delivery.order.number }}</span>
                                                    </td>
                                                    <td> <span v-if="delivery.deal" v-html="truncate(delivery.deal.number + ' - ' + delivery.deal.name, 30)"></span></td>
                                                    <td>{{ formatDate(delivery.shipped_at) }}</td>
                                                    <td>{{ formatDate(delivery.delivered_at) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- Pagination Front-End -->
                                    <div class="d-flex justify-content-between align-items-center mt-3" v-if="totalPages > 1">
                                        <div class="text-muted text-sm small">
                                            Affichage de {{ (currentPage - 1) * perPage + 1 }} à {{ Math.min(currentPage * perPage, filteredDeliveries.length) }} sur {{ filteredDeliveries.length }}
                                        </div>
                                        <nav>
                                            <ul class="pagination pagination-sm m-0">
                                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                    <button class="page-link" @click="currentPage--" :disabled="currentPage === 1">Précédent</button>
                                                </li>
                                                <li class="page-item disabled">
                                                    <span class="page-link text-dark bg-white font-weight-bold px-3">Page {{ currentPage }} / {{ totalPages }}</span>
                                                </li>
                                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                    <button class="page-link" @click="currentPage++" :disabled="currentPage === totalPages">Suivant</button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div class="custom-control custom-checkbox ml-3 mt-2">
                                    <input type="checkbox" class="custom-control-input" id="showOnlySelectedCheck" v-model="showOnlySelected" @change="currentPage = 1">
                                    <label class="custom-control-label font-weight-normal text-secondary cursor-pointer" for="showOnlySelectedCheck">
                                        Afficher les BL sélectionnés
                                    </label>
                                </div>
                            </div>
                           
                            <div class="row" v-if="!loading && deliveries && deliveries.length == 0 && company">
                                <div class="col-sm-12">
                                    <div class="alert alert-warning">Aucun bon de livraison disponible</div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loading" @click="post()">
                                <span v-if="!loading">Enregistrer</span>
                                <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i></span>
                            </button>
                        </div>

                   </div>

               </div>
        </div>
    </div>
    
</template>


<script>



export default {
    name: 'GroupDeliveries',
    props: ['companyUrl', 'deliveriesUrl', 'dealsUrl', 'allowGuarantee'],
    data(){
        return {
            company: null,
            company_id: null,
            deliveries : [],
            loading: false,
            selectedDeliveries: [],
            selectAll: false,
            searchQuery: '',
            showOnlySelected: false,
            currentPage: 1,
            perPage: 20,
        }
    },
    computed: {
        filteredDeliveries() {
            if (!this.deliveries) return [];
            
            return this.deliveries.filter(delivery => {
                // Filtre par sélection
                if (this.showOnlySelected && !delivery.isSelected) {
                    return false;
                }
                
                // Filtre par recherche textuelle (Numéro, désignation, commande, affaire)
                if (this.searchQuery) {
                    const query = this.searchQuery.toLowerCase();
                    const numberMatch = delivery.number ? delivery.number.toLowerCase().includes(query) : false;
                    const designationMatch = delivery.designation ? delivery.designation.toLowerCase().includes(query) : false;
                    const orderMatch = (delivery.order && delivery.order.number) ? delivery.order.number.toLowerCase().includes(query) : false;
                    
                    let dealMatch = false;
                    if (delivery.deal) {
                        const dealNum = delivery.deal.number ? delivery.deal.number.toLowerCase() : '';
                        const dealName = delivery.deal.name ? delivery.deal.name.toLowerCase() : '';
                        dealMatch = dealNum.includes(query) || dealName.includes(query);
                    }
                    
                    return numberMatch || designationMatch || orderMatch || dealMatch;
                }
                
                return true;
            });
        },
        paginatedDeliveries() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredDeliveries.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.filteredDeliveries.length / this.perPage);
        }
    },
    methods : {
        openModal(){
            $('#opendeliveriesModal').modal()
        },
        formatDate(date) {
            if (!date) return '-';
            return this.moment(date).format('DD/MM/YYYY');
        },
        removeCompany(){
            this.company = null;
            this.company_id = null;
            this.deliveries = [];
            this.selectedDeliveries = [];
            this.selectAll = false;
            this.searchQuery = '';
            this.showOnlySelected = false;
            this.currentPage = 1;
            $('#companySearchInput').val('');
        },
        removeDeal(){
            this.deal.id = null;
            this.deal.designation = null;
        },
        addDeliveries(company){
            this.deliveries = [];
            this.selectedDeliveries = [];
            if(company.deliveries && company.deliveries.length > 0){
                this.deliveries = company.deliveries;
            }
        },
        addSelectedDelivery(delivery){
             // Check if the delivery is selected, then add it to selectedDeliveries
            if (delivery.isSelected ) {
                const existingIndex = this.selectedDeliveries.findIndex(selectedDelivery => selectedDelivery.id === delivery.id);
                if (existingIndex === -1) {
                    // If the delivery does not exist, add it to selectedDeliveries
                    this.selectedDeliveries.push(delivery);
                  
                }
            } else {
                // If not selected, remove it from selectedDeliveries
                const index = this.selectedDeliveries.findIndex(selectedDelivery => selectedDelivery.id === delivery.id);
                if (index !== -1) {
                    this.selectedDeliveries.splice(index, 1);
                }
                
            }
        },
        addAllSelectedDelivery(){
              if (this.filteredDeliveries && this.filteredDeliveries.length > 0) {
                this.filteredDeliveries.forEach(delivery => {
                    if (delivery) {
                        delivery.isSelected = this.selectAll;
                        this.addSelectedDelivery(delivery);
                    }
                });
            }
        },
        checkForm(){
            return this.company != null && this.selectedDeliveries && this.selectedDeliveries.length >= 2;
        },
        async post(){
            this.loading = true
          
            var data = {
                company_id: this.company_id,
                deliveryIds : this.selectedDeliveries.map(delivery => {return delivery.id }),
            }


            fetch(this.deliveriesUrl, {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: 'POST',
                    body: JSON.stringify(data)
                }
            }).then((response) => {
              return response.json();
            }).then((data) => {
                window.location.href = data.redirect;
            }).catch((error) => {
                console.log(error);
            });
        }
    },
    mounted() { 
        $("#companySearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.companyUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, with_relations: 1 },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                       
                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.designation}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                search: (e, item) => {
                    if ($(e.target).val() == '' || $(e.target).val() == null) {
                        this.removeCompany();
                    }
                },
                change: (e, item) => {
                    if(!item.item){   
                        this.removeCompany();    
                    }
                },
                select: (e, item) => {
                    console.log(item);
                    if (item.item) {
                      this.company = item.item.designation
                      this.company_id = item.item.id;
                      this.loading = true;
                      this.addDeliveries(item.item);
                      this.loading = false;
                
                    }
                },
            }).focus(() => {
                $("#companySearchInput").autocomplete("search", '');
        });

    },
}
</script>

<style scoped>
.ix-selection-pill {
    display: inline-flex;
    align-items: center;
    padding: 6px 14px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 50px;
    color: #475569;
    font-size: 13px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.ix-selection-pill i {
    color: #94a3b8;
    font-size: 14px;
    transition: color 0.25s ease;
}

.ix-selection-count {
    font-weight: 700;
    color: #475569;
    margin-right: 4px;
    transition: color 0.25s ease;
}

.ix-selection-label {
    color: #64748b;
}

/* Changement de couleur dynamique quand une sélection est active (look pro moderne) */
.ix-selection-pill.has-selection {
    background-color: #eef2ff;
    border-color: #c7d2fe;
    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.05);
}

.ix-selection-pill.has-selection i {
    color: #4f46e5; /* Indigo */
}

.ix-selection-pill.has-selection .ix-selection-count {
    color: #312e81; /* Deep indigo */
}

.ix-selection-pill.has-selection .ix-selection-label {
    color: #4f46e5;
}

.cursor-pointer {
    cursor: pointer;
}

.row-has-invoices {
    background-color: #FCF8F8 !important; /* Un gris clair moderne et élégant */
}
</style>